import React from "react";
import "../StatusSaverPrivacyPolicy.css";
import { useNavigate } from "react-router-dom";
import SEO from "./SEO";

const ResumeBuilderPrivacyPolicy = () => {
  const navigate = useNavigate();

  const goHome = () => {
    navigate("/");
  };

  return (
    <div className="privacy-policy-page">
      <SEO
        title="Privacy Policy - Resume Builder | BlueOrbit Technologies"
        description="Privacy Policy for Resume Builder & CV Maker app by BlueOrbit Technologies."
        keywords="resume builder privacy policy, cv maker privacy, data protection, BlueOrbit Technologies"
      />

      <header className="privacy-header">
        <div className="container">
          <nav className="nav">
            <div
              className="logo"
              onClick={goHome}
              style={{ cursor: "pointer" }}
            >
              <i className="fas fa-orbit"></i>
              <span>BlueOrbit Technologies</span>
            </div>
          </nav>
        </div>
      </header>

      <section className="privacy-hero">
        <div className="container">
          <h1>Privacy Policy</h1>
          <ul className="breadcrumb">
            <li><a href="/">Home</a></li>
            <li><a href="/">Apps</a></li>
            <li>Privacy Policy</li>
          </ul>
        </div>
      </section>

      <section className="privacy-content">
        <div className="container">
          <div className="privacy-header">
            <h2>Privacy Policy for Resume Builder & CV Maker</h2>
            <p className="effective-date">Effective Date: 14-12-2025</p>
          </div>

          <div className="policy-content">

            <div className="policy-section">
              <h3>1. Information We Collect</h3>
              <p>
                We respect your privacy. Our Resume Builder app does not
                automatically collect personal data.
              </p>
              <ul>
                <li>
                  <strong>User-Provided Information:</strong> Resume details
                  such as name, education, experience, and skills are entered
                  voluntarily by you and remain on your device.
                </li>
                <li>
                  <strong>Non-Personal Information:</strong> We may collect
                  anonymous usage statistics (such as feature usage and app
                  performance) to improve the app.
                </li>
              </ul>
            </div>

            <div className="policy-section">
              <h3>2. How We Use Your Information</h3>
              <p>Your information is used only to:</p>
              <ul>
                <li>Create and format resumes within the app</li>
                <li>Allow users to export resumes as PDF</li>
                <li>Improve app performance and usability</li>
                <li>Fix bugs and enhance features</li>
              </ul>
              <p>
                We do <strong>not</strong> use your resume data for advertising,
                profiling, or tracking.
              </p>
            </div>

            <div className="policy-section">
              <h3>3. Data Storage</h3>
              <p>
                All resume data is stored locally on your device unless you
                choose to export or share it.
              </p>
              <ul>
                <li>No resume data is uploaded to our servers</li>
                <li>No cloud storage is used without user action</li>
              </ul>
            </div>

            <div className="policy-section">
              <h3>4. Permissions</h3>
              <p>The app may request the following permissions:</p>
              <ul>
                <li>
                  <strong>Storage Access:</strong> Required to save and export
                  resumes as PDF files on your device.
                </li>
                <li>
                  <strong>Internet Access (optional):</strong> Used for updates,
                  analytics, or sharing resumes if enabled by the user.
                </li>
              </ul>
              <p>
                Permissions are strictly used for app functionality only.
              </p>
            </div>

            <div className="policy-section">
              <h3>5. Sharing of Information</h3>
              <p>
                We do not sell, rent, or share your personal information with
                third parties.
              </p>
              <ul>
                <li>Resume sharing is fully controlled by the user</li>
                <li>Exported PDFs are handled locally on your device</li>
              </ul>
            </div>

            <div className="policy-section">
              <h3>6. Data Security</h3>
              <p>
                We take reasonable steps to protect your information. However,
                no method of electronic storage is completely secure. Users are
                responsible for safeguarding exported resume files.
              </p>
            </div>

            <div className="policy-section">
              <h3>7. Third-Party Services</h3>
              <p>
                The app may use third-party tools such as:
              </p>
              <ul>
                <li>Analytics services for anonymous usage insights</li>
                <li>PDF generation libraries</li>
              </ul>
              <p>
                These services follow their own privacy policies.
              </p>
            </div>

            <div className="policy-section">
              <h3>8. Children's Privacy</h3>
              <p>
                This app is not intended for children under the age of 13. We do
                not knowingly collect personal data from children.
              </p>
            </div>

            <div className="policy-section">
              <h3>9. Changes to This Privacy Policy</h3>
              <p>
                We may update this policy from time to time. Any changes will be
                reflected on this page with an updated effective date.
              </p>
            </div>

            <div className="policy-section">
              <h3>10. Contact Us</h3>
              <p>
                If you have any questions about this Privacy Policy, contact us:
              </p>
              <p>
                <strong>Email:</strong> blueorbittechnologies@gmail.com
              </p>
              <p>
                By using the Resume Builder app, you agree to this Privacy Policy.
              </p>
            </div>

          </div>
        </div>
      </section>

      <footer className="privacy-footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <h3>BlueOrbit Technologies</h3>
              <p>
                Building simple, powerful apps that help users grow their
                careers.
              </p>
            </div>

            <div className="footer-section">
              <h3>Quick Links</h3>
              <ul>
                <li><a href="/">Home</a></li>
                <li><a href="/">Our Apps</a></li>
                <li><a href="/contact">Contact</a></li>
              </ul>
            </div>
          </div>

          <div className="footer-bottom">
            <p>&copy; 2025 BlueOrbit Technologies. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ResumeBuilderPrivacyPolicy;
